<template>
  <div class="annualMeetingDetail" v-on:contextmenu="handleRightClick">
    <!-- <heads></heads> -->
    <div class="container"  v-if="!loading" >
      <!-- <div class="container-top" ref="contentTopRef">
        <div
          class="cover-img"
          :style="{ backgroundImage: 'url(' +'\'' + detailResult.image +'\'' + ')' }"
        >

        </div>
        <div class="cover-shadow"></div>
        <div class="main-content">
          <div class="container-top-title">{{ detailResult.title }}</div>
          <div class="container-top-subtitle">
            {{ detailResult.subtitle }}
          </div>
          <div class="container-top-tag" v-if="detailResult.meetingTagVoList">
            <span
              v-for="item in detailResult.meetingTagVoList"
              :key="item.id"
              >{{ item.name }}</span
            >
          </div>
          <div class="container-top-content">
            <div
              class="left-img"
              :style="{ backgroundImage: 'url('+'\'' + detailResult.image +'\'' + ')' }"
            ></div>
            <div class="right">
              <div class="member-prices">
                <div class="member">
                  <div
                    class="member-icon"
                    v-bind:style="{
                      backgroundImage: 'url(' +'\''+ detailResult.plannerIcon +'\''+ ')',
                    }"
                  ></div>
                  <div class="member-name">
                    {{
                      detailResult.plannerName
                        ? detailResult.plannerName
                        : "蓝星球年会策划师"
                    }} |
                    {{
                      detailResult.plannerJob
                        ? detailResult.plannerJob
                        : "年会策划师"
                    }}
                  </div>
                </div>
                <div class="prices">
                  <div class="price">
                    <span>{{
                      detailResult.price ? detailResult.price : "-"
                    }}</span>
                  </div>
                  <div class="avg-price">
                    {{
                      detailResult.avgPrice ? detailResult.avgPrice : "-"
                    }}人均价
                  </div>
                </div>
              </div>
              <p class="recommend">
                {{ detailResult.introduce }}
              </p>
              <div class="exponents">
                <div class="exponent" v-if="detailResult.eatIndex > 3">
                  <span class="exponent-text">餐饮指数</span>
                  <el-rate
                    style="displasy: inline"
                    disabled
                    v-model="detailResult.eatIndex"
                    :colors="['#99A9BF', '#F7BA2A', '#18d3a0']"
                  >
                  </el-rate>
                </div>
                <div class="exponent" v-if="detailResult.interestIndex > 3">
                  <span class="exponent-text">趣味指数</span>
                  <el-rate
                    style="displasy: inline"
                    disabled
                    v-model="detailResult.interestIndex"
                    :colors="['#99A9BF', '#F7BA2A', '#18d3a0']"
                  >
                  </el-rate>
                </div>
                <div
                  class="exponent"
                  v-if="detailResult.environmentalIndex > 3"
                >
                  <span class="exponent-text">环境指数</span>
                  <el-rate
                    style="displasy: inline"
                    disabled
                    v-model="detailResult.environmentalIndex"
                    :colors="['#99A9BF', '#F7BA2A', '#18d3a0']"
                  >
                  </el-rate>
                </div>
                <div
                  class="exponent"
                  v-if="detailResult.accommodationIndex > 3"
                >
                  <span class="exponent-text">住宿指数</span>
                  <el-rate
                    style="displasy: inline"
                    disabled
                    v-model="detailResult.accommodationIndex"
                    :colors="['#99A9BF', '#F7BA2A', '#18d3a0']"
                  >
                  </el-rate>
                </div>
              </div>
              <div class="right-bottom">
                <div class="header-tags">
                  <div class="header-tag">
                    <i class="el-icon-time"></i>
                    <span
                      >{{ detailResult.day ? detailResult.day : "-" }}天{{
                        detailResult.night ? detailResult.night : "-"
                      }}晚</span
                    >
                  </div>
                  <div class="header-tag">
                    <i class="el-icon-s-custom"></i>
                    <span
                      >{{
                        detailResult.numberMin ? detailResult.numberMin : "0"
                      }}-{{
                        detailResult.numberMax
                          ? detailResult.numberMax
                          : "不限"
                      }}人</span
                    >
                  </div>
                </div>
                <div class="header-required" @click="showDialog">
                  年会定制咨询
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="container-bottom-out">
        <div class="container-bottom" ref="containerBottomRef">
          <div>
            <div class="child-page"                 
                v-for="tbInfo in tbInfoList"
                :key="tbInfo.id">
                 <fullPic v-if="tbInfo.style == '1'" :pic="tbInfo.image1"  :link="tbInfo.link1"/>                 
                 <headerPic v-if="tbInfo.style == '2'" :backgroundPic="tbInfo.image1"  :tb="detailResult" type="annualMeeting" @openAnnualMeeting="showDialog"/>                 
                 <schedulePic v-if="tbInfo.style == '3'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <twoPic v-if="tbInfo.style == '4'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <twoPicWord v-if="tbInfo.style == '5'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <threePicAvg v-if="tbInfo.style == '6'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <threePic v-if="tbInfo.style == '7'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <fourPic v-if="tbInfo.style == '8'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <sixPic v-if="tbInfo.style == '9'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
                 <eightPic v-if="tbInfo.style == '10'" :backgroundPic="tbCover"  :tbInfo="tbInfo"/>                 
          </div> 
          </div>
          <div>
          <div class="child-page"                 
                v-for="(item, index) in tbBackCovers"
                :key="index">
                <fullPic :pic="item"/>                  
          </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-page" v-if="loading"  v-loading="loading">
      <!-- <el-empty description="加载中"></el-empty> -->
    </div>
    <homeFoots :message="message"></homeFoots>
    <!-- <quickContact :message="message"></quickContact> -->

    <el-dialog :visible.sync="dialogVisible" width="0%">
      <div v-if="dialogVisible" class="tool-booking">
        <div class="tool-booking-order">
          <div class="title">
            {{ detailResult.title }}
          </div>
          <div class="subtitle">
            <div class="subtitle-left">
              <div class="header-tags">
                <i class="el-icon-time"></i>
                <span
                  >{{ detailResult.day ? detailResult.day : "-" }}天{{
                    detailResult.night ? detailResult.night : "-"
                  }}晚</span
                >
                <i class="el-icon-s-custom"></i>
                <span
                  >{{
                    detailResult.numberMin ? detailResult.numberMin : "0"
                  }}-{{
                    detailResult.numberMax ? detailResult.numberMax : "不限"
                  }}人</span
                >
              </div>
            </div>
            <div class="subtitle-right">
              <div class="price">
                <span>{{ detailResult.price ? detailResult.price : "-" }}</span>
              </div>
              <div class="avg-price">
                {{ detailResult.avgPrice ? detailResult.avgPrice : "-" }}人均价
              </div>
            </div>
          </div>
          <div class="element-row" style="height: 54px">
            <div class="element-col" style="height: 54px; padding-right: 82px;positon:relative;left:1px;">
              <span class="txt">出行人数</span>
              <el-input
                v-model="customForm.peopleNumber"
                placeholder="出行人数"
                style="display: inline"
              ></el-input>
            </div>
            <div
              class="element-col"
              style="height: 54px; padding-left: 8px padding-right: 12px"
            >
              <span class="txt">联系人</span>
              <el-input
                v-model="customForm.contact"
                placeholder="联系人"
                style="display: inline"
              ></el-input>
            </div>
          </div>
          <div class="element-row" style="height: 54px">
            <div
              class="element-col"
              style="height: 54px; padding-right: 75px; box-sizing: border-box;positon:relative;left:-3px;"
            >
              <span class="txt request">联系电话</span>
              <el-input
                v-model="customForm.mobile"
                placeholder="联系电话"
                style="display: inline"
              ></el-input>
            </div>
            <div
              class="element-col"
              style="height: 54px; padding-left: 0px; padding-right: 0px"
            >
              <span class="txt request">验证码</span>
              <div class="sendCode">
                <el-input
                  v-model="customForm.verificationCode"
                  placeholder="4位验证码"
                  style="display: inline"
                ></el-input>
                 <span
                class="txt2"
                :class="isPhoneNumber(customForm.mobile) ? 'active-txt2' : ''"
                @click="sendCustomSMS(customForm)"
                >{{ customSmsCodeTime != 0 ? customSmsCodeTime : "短信验证" }}</span
              >
              </div>
            </div>
          </div>
          <div class="element-row" style="height: 54px">
            <div class="element-col" style="height: 54px; margin-left: 5%">
              <span class="txt">备注</span>
              <div class="inner-textarea">
                <el-input
                  type="textarea"
                  v-model="customForm.description"
                  placeholder="非必填 如有特殊需求请填写备注告诉我们～"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="element-row">
            <div class="element-col element-col-span-8">
              <div
                class="
                  tool-button tool-booking-order-submit tool-button-primary
                "
                 @click="customSubmit"
              >
                提交年会需求
              </div>
            </div>
          </div>
          <span class="tool-booking-order-close" @click="closeDialog">×</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="getCustomFormState" width="25%">
      <annualMeetingCustomForm></annualMeetingCustomForm>
    </el-dialog>
  </div>
</template>
<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import rquirementsForm from "@/components/comment/rquirementsForm.vue";
import quickContact from "@/components/comment/quickContact.vue";
import annualMeetingCustomForm from "@/components/annualMeeting/annualMeetingCustomForm.vue";
import { handlePicPlusPre,isPhoneNumber,regEditorChange } from "@/util/util.js";
import fullPic from "@/components/comment/tbChildPage/fullPic"
import schedulePic from '@/components/comment/tbChildPage/schedulePic';
import headerPic from '@/components/comment/tbChildPage/headerPic'; 
import twoPic from '@/components/comment/tbChildPage/twoPic';
import twoPicWord from '@/components/comment/tbChildPage/twoPicWord';
import threePicAvg from '@/components/comment/tbChildPage/threePicAvg';
import threePic from '@/components/comment/tbChildPage/threePic';
import fourPic from '@/components/comment/tbChildPage/fourPic';
import sixPic from '@/components/comment/tbChildPage/sixPic';
import eightPic from '@/components/comment/tbChildPage/eightPic';
import axios from "axios";
import wxShare from "@/common/wx_share.js";
export default {
  name: "annualMeetingDetail",
  data() {
    return {
      nav: 0,
      navArray: ["场地特色", "活动流程", "费用说明", "预订须知"],
      scrollTop: 0,
      divtop: 0,
      scroll: "",
      imageCount: 0,
      smsCodeTime: 0,
      customSmsCodeTime:0,
      // 提交表单
      form: {
        peopleNumber: null,
        activityDay: null,
        meetingTypeId:null,
        contact: null,
        mobile: "",
        verificationCode: "",
        wxNo: null,
        description: null,
      },
      // 提交定制表单
      customForm: {
        peopleNumber: null,
        activityDay: null,
        meetingTypeId:null,
        contact: null,
        mobile: "",
        verificationCode: "",
        wxNo: null,
        description: null,
      },
      dataForm: {
        title: "",
      },
      message: {
        type: 2,
      },
      requireDialogVisible: false,

      iconClasses: ["el-icon-minus"],
      //swiper配置
      swiperOptionTop: {
        autoplay: true,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        swiperLoading: false,
      },
      swiperOptionThumbs: {
        autoplay: true,
        direction: "vertical",
        spaceBetween: 5,
        slidesPerView: "auto",
        centeredSlides: true,
        touchRatio: 0.2,
        loop: true,
        slidesPerview: "auto",
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        slideToClickedSlide: true,
      },

      // 详情列表
      tbInfoList:[],
      // 背景
      tbCover:"",
      // 关于我们
      tbBackCovers:[],
      loading: false,

      //offsetTop参数
      oneTop: 0,
      twoTop: 0,
      threeTop: 0,
      fourTop: 0,

      //年会详情参数
      id: "",
      freeBookingStyle: 2,
      topHeight: "700px",
      detailResult: {},

      // 弹框参数
      // 是否弹框
      dialogVisible: false,
    };
  },
  watch: {},
  components: {
    heads,
    homeFoots,
    rquirementsForm,
    quickContact,
    annualMeetingCustomForm,
    fullPic,
    schedulePic,
    headerPic,
    twoPic,
    twoPicWord,
    threePicAvg,
    threePic,
    fourPic,
    sixPic,
    eightPic
  },

  computed: {
    // 获取需求类型
    getRequirementType() {
      return this.$store.state.requirementTypeData;
    },
    // 获取免费定制弹出框的值
    getCustomFormState() {
      return this.$store.state.annualMeetingCustomState;
    },
  },
  methods: {
    handlePicPlusPre,
    isPhoneNumber,
    regEditorChange,
    closeDialog(val) {
      // console.log(val);
      this.clearCustomForm();
      this.dialogVisible = false;
    },
    showDialog(val) {
      // console.log(val);
      this.dialogVisible = true;
    },
    // 阻止右键
    handleRightClick (event) {
      event.preventDefault()
    },
    // 查看年会明细
    meetingDetail() {
      this.loading = true;
      axios.get(`/api/meeting/` + this.id).then((res) => {
        if (res.data && res.data.code == 200) {
          this.detailResult = res.data.data;
          this.tbInfoList = this.detailResult.tbInfoList;
          this.tbCover = this.detailResult.tbCover;
          this.tbBackCovers = this.detailResult.tbBackCovers;
          if (this.detailResult.image) {
            this.detailResult.image = handlePicPlusPre(this.detailResult.image);
          }
          let { id, title, day, night, price, avgPrice, numberMax, numberMin } =
            this.detailResult;
          this.dataForm = {
            id,
            title,
            day,
            night,
            price,
            avgPrice,
            numberMax,
            numberMin,
          };
          if (this.detailResult.title) {
              document.title = this.detailResult.title;
          }
          if (this.detailResult.fee) {
            this.detailResult.fee = regEditorChange(
              this.detailResult.fee
            );
          }
          if (this.detailResult.feeWithout) {
            this.detailResult.feeWithout = regEditorChange(
              this.detailResult.feeWithout
            );
          }
          if (this.detailResult.bookingInformation) {
            this.detailResult.bookingInformation = regEditorChange(
              this.detailResult.bookingInformation
            );
          }
          if (this.detailResult.tip) {
            this.detailResult.tip = regEditorChange(
              this.detailResult.tip
            );
          }
          // 个人图像图片
          if (this.detailResult.plannerIcon) {
            this.detailResult.plannerIcon = handlePicPlusPre(
              this.detailResult.plannerIcon
            );
            this.detailResult.plannerIcon = this.detailResult.plannerIcon[0];
          }
          //场地图片
          if (this.detailResult.tbPlaceList) {
            this.detailResult.tbPlaceList.forEach((tbPlace) => {
              if (tbPlace.image) {
                tbPlace.image = handlePicPlusPre(tbPlace.image);
              }
            });
          }

          // 行程图片
          if (this.detailResult.scheduleList) {
            this.detailResult.scheduleList.forEach((schedule) => {
              if (schedule.scheduleDetailVoList) {
                schedule.scheduleDetailVoList.forEach((detail) => {
                  if (detail.scheduleTypeImage) {
                    detail.scheduleTypeImage = handlePicPlusPre(
                      detail.scheduleTypeImage
                    )[0];
                  }
                  if (detail.schedulePictureVoList) {
                    detail.schedulePictureVoList.forEach((schedulePicture) => {
                      if (schedulePicture.image) {
                        schedulePicture.image = handlePicPlusPre(
                          schedulePicture.image
                        );
                      }
                    });
                  }
                });
              }
            });
          }
          this.loading = false;
          if (wxShare.is_wx()) {
              wxShare.wxReWriteShare(
                `${this.detailResult.title}`,
                `${this.detailResult.subtitle}`,
                `${window.location.href}`,
                `${(this.detailResult.image && this.detailResult.image.length > 0)
                    ? this.detailResult.image[0]
                    : this.$store.state.defaultPic
                }`
              );
            }
        }
      }).catch (e=>{
        this.loading = true;
      });
    },
    // 短信计时器
    smsDown() {
      setInterval(() => {
        if (this.smsCodeTime != 0) {
          this.smsCodeTime = this.smsCodeTime - 1;
        }
        if (this.customSmsCodeTime != 0) {
          this.customSmsCodeTime = this.customSmsCodeTime - 1;
        }
      }, 1000);
    },
     // 发送短信
    sendSMS() {
      if(this.smsCodeTime>0 || !isPhoneNumber(this.form.mobile)){
        return;
      }
      let params = { mobile: this.form.mobile };
      axios
        .get(`/api/verificationCode/sendCode`, {
          params,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.code == 200) {
              // 成功则重置短信验证码时间
              this.smsCodeTime = 60;
              this.smsDown();
            } else {
              if (res.data.code == 500) {
                let msg = "";
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "短信发送失败";
                }
                this.$message({
                  message: msg,
                  type: "warning",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
   sendCustomSMS() {
      if(this.customSmsCodeTime>0 || !isPhoneNumber(customForm.mobile)){
        return;
      }
      let params = { mobile: this.customForm.mobile };
      axios
        .get(`/api/verificationCode/sendCode`, {
          params,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.code == 200) {
              // 成功则重置短信验证码时间
              this.customSmsCodeTime = 60;
              this.smsDown();
            } else {
              if (res.data.code == 500) {
                let msg = "";
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "短信发送失败";
                }
                this.$message({
                  message: msg,
                  type: "warning",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    // 清除表单
    clearForm(){
      // 提交表单
      this.form = {
        peopleNumber: null,
        meetingTypeId:null,
        activityDay: null,
        contact: null,
        mobile: "",
        verificationCode: "",
        wxNo: null,
        description: null,
      }
    },
    clearCustomForm(){
      // 提交表单
      this.customForm = {
        peopleNumber: null,
        // meetingTypeId:null,
        // activityDay: null,
        contact: null,
        mobile: "",
        verificationCode: "",
        // wxNo: null,
        description: null,
      }
    },
    // 提交表单
    submit() {
      let { mobile, verificationCode } = this.form;
      console.log(!mobile || mobile.length != 11);
      console.log(!verificationCode);
      if (!mobile || mobile.length != 11) {
        this.$message({
          message: "请正确填写手机号码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!verificationCode) {
        this.$message({
          message: "请正确填写验证码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      // this.form = {
      //   mobile,
      //   verificationCode,
      // };
      this.form.type = "2";
      let params = this.form;
      axios
        .post(`/api/requirement/submit`, JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          console.log(res);
          let msg = "";
          if (res.data) {
            if (res.data.code == 200) {
               if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "需求提交成功";
                }
                this.$message({
                  message: msg,
                  type: "success",
                  center: true,
                });
                this.clearForm();
            } else {
              if (res.data.code == 500) {
                
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "需求提交失败";
                }
                this.$message({
                  message: msg,
                  type: "error",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    },
    customSubmit(){
       let { mobile, verificationCode } = this.customForm;
      console.log(!mobile || mobile.length != 11);
      console.log(!verificationCode);
      if (!mobile || mobile.length != 11) {
        this.$message({
          message: "请正确填写手机号码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      if (!verificationCode) {
        this.$message({
          message: "请正确填写验证码",
          type: "warning",
          duration: 1500,
          center: true,
        });
        return;
      }
      // this.form = {
      //   mobile,
      //   verificationCode,
      // };
      this.customForm.type = "2";
      this.customForm.meetingId = this.dataForm.id;
      this.customForm.title = this.dataForm.title;
      let params = this.customForm;
      // let params = {
      //   peopleNumber: "",
      //   avgBudget: "",
      //   teamBuildingDay: "",
      //   contact: "",
      //   mobile: "",
      //   verificationCode: "",
      //   wxNo: "",
      //   description: "",
      // };
      axios
        .post(`/api/requirement/submit`, JSON.stringify(params), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((res) => {
          console.log(res);
          let msg = "";
          if (res.data) {
            if (res.data.code == 200) {
               if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "需求提交成功";
                }
                this.$message({
                  message: msg,
                  type: "success",
                  center: true,
                });
                this.closeDialog();
            } else {
              if (res.data.code == 500) {
                
                if (res.data.msg) {
                  msg = res.data.msg;
                } else {
                  msg = "需求提交失败";
                }
                this.$message({
                  message: msg,
                  type: "error",
                  duration: 1500,
                  center: true,
                });
              }
            }
          }
        });
    }
    // 定制表单区
  },
  mounted() {
    this.id = this.$route.query.id;
    this.meetingDetail();
    // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
  created() {
  },

  destroyed() {
  },
};
</script>

<style scoped>
.annualMeetingDetail {
  width: 100%;
  height: 100%;
  background-color: #000;
}
.annualMeetingDetail .container {
  text-align: left;
  margin-bottom: 20px;
  width: 100%;
}
.annualMeetingDetail .container-top {
  text-align: left;
  margin-bottom: 20px;
  width: 100%;
  height: 618px;
  position: relative;
}

.annualMeetingDetail .container-top .main-content {
  /* background-color: #ff0000;  */
  width: 1060px;
  margin: 0 auto;
  position: relative;
  z-index: 3;
}
.annualMeetingDetail .container-top-title {
  position: absolute;
  left: 0;
  top: 50px;
  font-weight: 700;
  font-size: 30px;
  color: #fff;
  text-shadow: 0 2px 4px rgb(0 0 0 / 50%);
}
.annualMeetingDetail .container-top-subtitle {
  position: absolute;
  left: 0;
  top: 98px;
  font-size: 16px;
  color: #fff;
}
.annualMeetingDetail .container-top-tag {
  position: absolute;
  left: 0;
  top: 140px;
  font-size: 14px;
  color: #fff;
  list-style: none;
}
.annualMeetingDetail .container-top-tag span {
  float: left;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #fff;
  border-radius: 15px;
  margin-right: 10px;
}

.container-top .cover-img {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  filter: blur(10px);
}
.container-top .cover-shadow {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 2;
  background-image: linear-gradient(0deg, rgba(24, 24, 24, 0) 6%, #181818);
}
.container-top .container-top-content {
  height: 386px;
  position: absolute;
  left: 0;
  right: 0;
  top: 211px;
  background: #fff;
  border-radius: 3px;
  display: flex;
  flex: row;
  padding: 20px;
  box-sizing: border-box;
}
.container-top-content .left-img {
  flex: 14;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
}
.container-top-content .right {
  flex: 16;
  padding-left: 10px;
  position: relative;
}
.right .member-prices {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.member-prices .member {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.member .member-icon {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  width: 40px;
  height: 40px;
  border-radius: 25px;
}
.member .member-name {
  font-size: 14px;
  color: #222;
  font-weight: 700;
  margin-left: 10px;
}
.member-prices .price {
}
.member-prices .price span {
  font-size: 28px;
  color: #f9541c;
  text-align: right;
  font-weight: 700;
}
.member-prices .price span::after {
  content: "元起/人";
  font-size: 20px;
  color: #666;
}
.member-prices .avg-price {
  font-size: 14px;
  color: #666;
  font-weight: 400;
  text-align: right;
}
.right .recommend {
  margin-top: 30px;
  font-size: 14px;
  color: #666;
  text-align: justify;
  line-height: 24px;
}
.right .exponents {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 30px;
}
.right .exponents .exponent {
  flex: 50%;
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
}
.right .exponents .exponent-text {
  color: #222;
  font-size: 14px;
  font-weight: 700;
  padding-right: 5px;
  top: 4px;
}

.right-bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  bottom: 20px;
  width: 100%;
  align-items: flex-end;
}
.right-bottom .header-tags {
  display: flex;
  flex-direction: column;
}
.right-bottom .header-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 10px;
}
.right-bottom .header-tags [class^="el-icon-"] {
  display: inline;
  font-weight: 700;
}
.right-bottom .header-tags span {
  display: inline;
  font-weight: 700;
  padding-left: 10px;
}
.right-bottom .header-required {
  color: #ffebbf;
  font-weight: 700;
  background: #fe4a43;
  border-radius: 22px;
  font-size: 16px;
  line-height: 44px;
  letter-spacing: 1.6px;
  height: 44px;
  text-align: center;
  padding: 0 15px;
  cursor: pointer;
  margin-right: 10px;
}
/* width: 1060px; */
.content {
  width: 100%;
}

/* 头部文案 */
.header-text {
  flex: 1;
  padding: 10px;
  background-color: white;
}
.header-text .header-title {
  font-weight: 700;
  font-size: 26px;
  color: #222;
  letter-spacing: -0.62px;
  line-height: 40px;
  overflow: hidden;
}
.header-text .header-purposes {
  margin-top: 12px;
}
.header-text .header-purposes span {
  padding: 0 6px;
  background: #359ff8;
  border-radius: 2px;
  height: 28px;
  line-height: 28px;
  display: inline-block;
  font-size: 12px;
  color: #fff;
  letter-spacing: 0;
  text-align: center;
  margin-right: 5.3px;
  margin-bottom: 5.3px;
}
.header-text .header-describe {
  margin-top: 16px;
  font-weight: 700;
  font-size: 14px;
  color: #999;
  letter-spacing: 1.4px;
  word-break: break-all;
  min-height: 42px;
  overflow: hidden;
}
.header-text .header-tags {
  margin-top: 10px;
}
.header-text .header-tags span {
  font-weight: 700;
  font-size: 12px;
  color: #222;
  line-height: 18px;
  height: 18px;
}
.header-text .header-submit {
  display: flex;
  flex-direction: row;
  padding-top: 10px;
}
.header-text .header-submit {
  display: flex;
  flex-direction: row;
  margin-top: 30px;
}
.header-text .header-submit .header-required {
  background: #222;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  border-radius: 6px;
  padding: 10px 60px;
}
.header-text .header-submit .header-consult {
  margin-left: 15px;
  background: transparent;
  padding: 10px;
  color: #18d3a0;
  font-weight: 700;
  cursor: pointer;
  border: 1px solid #18d3a0;
  border-radius: 6px;
  padding: 10px 50px;
}
.header-text .header-submit .header-consult span {
  margin-left: 5px;
}
.header-text .header-price {
  position: absolute;
  left: 800px;
  top: 200px;
  right: 10px;
  /* bottom: 70px; */
  font-weight: 700;
  font-size: 24px;
  color: #f9541c;
  text-align: right;
}

.header-text .header-price::after {
  content: "元起/人";
  font-weight: 700;
  font-size: 12px;
  color: #666;
  text-align: left;
  line-height: 28px;
}
.header-text .header-avg-price {
  position: absolute;
  left: 800px;
  top: 230px;
  right: 10px;
  text-align: right;
}
.header-text .header-avg-price span {
  font-size: 12px;
  color: #666;
}
.container-top {
  background-color: #f8f8f8;
  width: 1060px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
}
.container-bottom {
  background-color: #000;
  width: 1060px;
  display: flex;
  flex-direction: column;
}

.container-bottom .child-page{
  padding: 10px 0; 
  width:100%;
  height: 600px;
}
/* 正文 */
.container-bottom-out {
  margin: 0 auto;
  width: 1060px;
}
.container-bottom > .text {
  width: 746px;
  background-color: #fff;
  min-height: 800px;
}
.text .textnav {
  display: flex;
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
  /* padding: ; */
  box-sizing: border-box;
  background: #ffffff;
  position: sticky;
  position: -webkit-sticky;
  top: 60px;
  z-index: 1001;
}
.textnav > span {
  cursor: pointer;
  height: 100%;
  line-height: 60px;
  padding: 0 20px;
}
.text-col {
  display: inline-block;
  margin-top: 6px;
  font-weight: bold;
  color: #359ff8;
}
.nac-active {
  color: #359ff8;
  font-weight: bold;
  border-bottom: 5px solid #359ff8;
}
/* 正文内容 */
.text .article {
  position: relative;
}
.text .article .recommended {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.text .article .recommended .recommended-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: wrap;
  flex: 1;
  width: 60px;
  top: 20px;
  left: 0;
  text-align: center;
}
.text .article .recommended .recommended-left img {
  display: inline-block;
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 30px;
  overflow: hidden;
  background: #f8f8f8;
  border: none;
}
.recommended-left .middle-name {
  display: inline-block;
  width: 60%;
  font-weight: 700;
  font-size: 12px;
  color: #222;
  margin-top: 4px;
}
.recommended-left .bottom-name {
  display: inline-block;
  width: 60%;
  font-size: 12px;
  color: #18d3a1;
}
.recommended .recommended-right {
  display: flex;
  flex-direction: column;
  flex: 5;
  padding: 20px;
  background-color: #c2e2fd;
  border-radius: 6px;
  margin-right: 20px;
}
.recommended .recommended-right .exponents {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.recommended .recommended-right .exponent {
  flex: 50%;
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
}
.recommended .recommended-right .exponent .exponent-text {
  color: #222;
  font-size: 14px;
  font-weight: 700;
  padding-right: 5px;
  top: 4px;
}
.recommended .recommended-right .exponent .exponent-text {
  color: #222;
  font-size: 14px;
  font-weight: 700;
  padding-right: 5px;
  top: 4px;
}
.exponents-description {
  padding-top: 10px;
  width: 100%;
  display: block;
  font-size: 14px;
  color: #222;
  line-height: 24px;
}
.notes_text {
  margin: 20px;
}
.text .large-title {
  height: 60px;
  line-height: 60px;
  text-align: center;
  width: 100%;
}

.text .large-title .inner-title {
  display: inline-block;
  font-weight: 700;
  font-size: 30px;
  color: #222;
  letter-spacing: -0.71px;
  padding: 0 19px;
  vertical-align: middle;
}
.text .large-title .outside-dot {
  display: inline-block;
  background: #359ff8;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  margin: 0 10px;
  vertical-align: middle;
}
.text .large-title .inner-dot {
  display: inline-block;
  background: #359ff8;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  vertical-align: middle;
}

.text .second-title {
  height: 60px;
  line-height: 60px;
}
.text .second-title span:nth-child(1) {
  display: inline-block;
  background: #359ff8;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  vertical-align: middle;
}
.text .second-title .inner-title {
  display: inline-block;
  font-weight: 700;
  font-size: 18px;
  padding-left: 8px;
  color: #222;
  vertical-align: middle;
}
.text .building-topic {
}
.text .building-topic img {
  width: 100%;
  border-radius: 4px;
  background: #f8f8f8;
  background-size: cover;
}
.text .building-topic .topic-text {
  font-size: 14px;
  color: #222;
  line-height: 24px;
  padding: 10px 0;
}
.text .meeting-place {
}
.text .meeting-place .place-text {
}
.text .meeting-place .place-text .litte-title {
  font-weight: 700;
  font-size: 16px;
  color: #222;
  letter-spacing: 0;
  line-height: 44px;
}
.text .meeting-place .place-text p {
  font-size: 14px;
  color: #101010;
  line-height: 24px;
  padding-bottom: 20px;
}
.text .meeting-place .couple-img {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.text .meeting-place .couple-img img {
  flex: 1;
  padding: 5px;
  background-size: cover;
  width: 40%;
}
.tour-itinerary-item {
  position: relative;
}
.tour-header-item {
  position: relative;
  top: -35px;
  left: 0px;
}
.tour-header-item >>> .el-timeline-item__timestamp,
.tour-itinerary-item >>> .el-timeline-item__timestamp {
  color: #0000 !important;
}
.tour-header-item .tour-header-left {
  margin-right: 10px;
  padding-left: 0px;
  display: inline;
}
.tour-detail-header {
  position: relative;
  top: -13px;
  left: 0px;
}
.tour-detail-header .tour-header-left {
  margin-right: 10px;
  padding-left: 0px;
  display: inline;
}
.tour-header-right,
.tour-detail-left {
  margin-right: 10px;
  display: inline;
  font-weight: 700;
  font-size: 16px;
  color: #222;
  letter-spacing: 0;
  text-align: left;
}
.tour-header-right,
.tour-detail-right {
  margin-right: 10px;
  padding-left: 10px;
  display: inline;
}
.tour-header-item img {
  display: inline;
  /* color: #ffc53d; */
  /* font-size: 22px;
  padding: 0 10px; */
  width: 30px;
  /* line-height: 36px; */
  height: 30px;
  display: inline-block;
  vertical-align: middle;
}
.tour-header-item .icon {
  display: inline;
  position: absolute;
  left: -38px;
  top: 5px;
  width: 30px;
  height: 30px;
  background: #359ff8;
  border-radius: 50% 50% 50% 4%;
  transform: rotate(-45deg);
  color: #fff;
}
.tour-header-item .icon .day {
  transform: rotate(45deg);
  display: inline-block;
  position: relative;
  left: -7px;
  top: -5px;
  color: #fff;
}

.tour-header-item span {
  display: inline;
  font-weight: 700;
  font-size: 18px;
  width: 100%;
  color: #222;
  letter-spacing: 0;
  text-align: left;
  padding-left: 10px;
  height: 40px;
  line-height: 36px;
  margin-bottom: 20px;
  vertical-align: middle;
}
.tour-itinerary-item >>> .tour-header .el-timeline-item__timestamp {
  font-weight: 700;
  font-size: 18px;
  color: #222;
  letter-spacing: 0;
  text-align: left;
}
.tour-itinerary-item >>> .el-timeline-item__timestamp {
  font-weight: 700;
  font-size: 16px;
  color: #222;
  letter-spacing: 0;
  text-align: left;
  /* padding-left: 40px; */
  /* display: inline-block; */
}
.tour-itinerary-item p {
  font-size: 14px;
  color: #999;
  text-align: left;
  padding: 10px 0 10px 0px;
}

.tour-itinerary-item .tour-itinerary-couple-img {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
}
.tour-itinerary-item .tour-itinerary-couple-img img {
  flex: 1;
  padding: 10px 20px 10px 0px;
  background-size: cover;
  height: 243px;
  width: 100%;
  object-fit: cover;
}
.tour-detail-header .tour-detail-header-right {
  position: relative;
  display: inline;
}
.tour-detail-header .type-icon {
  width: 18px;
  height: 18px;
  position: absolute;
  left: -32px;
  top: 5px;
}
@media (min-width: 768px) {
  .tour-itinerary-couple-img img {
    display: block;
    flex: 0 0 50%;
    max-width: 46%;
  }
}
.three table, three table thead{
  width: 100%;
}
.three table thead td {
  color: #222;
  font-size: 18px;
  text-align: center;
  background-color: #c2e2fd;
  padding: 10px;
}
.three table tbody td {
  color: #222;
  font-size: 14px;
  letter-spacing: 0;
  /* text-align: center; */
  background-color: #f8f8f8;
  padding: 10px;
  vertical-align: top;
}
.three table td {
  border: 1px solid #fff;
  width: 50%;
}
.three table tbody td .fee-content-item {
  padding: 10px;
  display: flex;
  flex-direction: row;
}
.three table tbody .fee-content-item span {
  font-weight: 700;
  flex: 1;
  font-size: 14px;
}
.three table tbody .fee-content-item p {
  flex: 4;
  font-size: 14px;
  text-align: left;
}
.three table tbody td .fee-without-item {
  padding: 10px;
  display: flex;
  flex-direction: row;
}
.three table tbody .fee-without-item span {
  position: relative;
  left: -6px;
  top: 6px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #666;
  display: block;
}
.three table tbody .fee-without-item p {
  flex: 4;
  font-size: 14px;
  text-align: left;
}
.four-detail {
  /* display: flex;
  flex-direction: row; */
  font-size: 14px;
  letter-spacing: 0;
}
.four-detail span {
  margin-top: 12px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #359ff8;
  flex: 1;
  display: block;
}
.four-detail p {
  font-size: 14px;
  color: #101010;
  letter-spacing: 0;
  line-height: 30px;
  padding-left: 16px;
  flex: 120;
}
.five-detail {
  /* display: flex;
  flex-direction: row; */
  font-size: 14px;
  letter-spacing: 0;
}
.five-detail span {
  margin-top: 12px;
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #359ff8;
  display: block;
  flex: 1;
}
.five-detail p {
  font-size: 14px;
  color: #101010;
  letter-spacing: 0;
  line-height: 30px;
  padding-left: 16px;
  flex: 120;
}
/* 免费定制 */
.free-booking {
  left: auto;
  margin-top: 0px;
  width: 300px;

  /* bottom: 20px; */
  z-index: 0;
  margin-left: 756px;
  background: #fe4a43;
  /* border: 2px solid #359ff8; */
  border: none;
  border-radius: 24px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: column;
}
.free-booking-1 {
  position: fixed;
  top: 80px;
}
.free-booking-2 {
  position: absolute;
  /* top: 750px; */
  /* position: relative;
    top: -2100px; */
}
.free-booking .free-booking-header {
  text-align: center;
}
.free-booking .free-booking-header .free-booking-dot {
  display: inline-block;
  background: #ffebbf;
  width: 12px;
  height: 12px;
  border-radius: 6px;
  vertical-align: middle;
  margin: 0 10px;
}
.free-booking .free-booking-header .free-booking-title {
  display: inline-block;
  font-weight: 700;
  font-size: 20px;
  color: #ffebbf;
  letter-spacing: 1px;
  height: 80px;
  line-height: 80px;
  vertical-align: middle;
}
.free-booking-item {
  position: relative;
  padding: 9px 25px 9px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
}
.free-booking-item .txt {
  display: inline;
  flex: 47;
  text-align: right;
  padding: 10px 5px 10px 0px;
}
.free-booking-item >>> div {
  flex: 100;
}

.sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  background: #f8f8f8;
  border-radius: 6px;
}
/* el-select 样式 */
.free-booking-item >>> .el-input__inner,
.free-booking-item >>> .el-input__suffix {
  background-color: #f8f8f8;
}
.free-booking .free-booking-item2 >>> .el-input__inner {
  width: 170px !important;
}
.free-booking-item >>> .el-input__inner {
  border: none;
  width: 170px !important;
  background-color: #f8f8f8;
}
.free-booking-item .sendCode >>> .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 105px !important;
  margin-top: 0px !important;
}
.free-booking-item .sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: #f9541c;
  cursor: pointer;
  width: 60px;
  opacity: 0.2;
  padding-right: 5px;
}
.free-booking-item .sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: #f9541c;
  cursor: pointer;
  width: 60px;
  opacity: 1;
  padding-right: 5px;
}
.free-booking .request::before {
  content: "*";
  color: #fff;
  position: relative;
}
.el-select-dropdown__list .selected {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  color: #606266 !important;
}
.free-booking-item .el-select-dropdown__item:hover {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  background: #f8f8f8;
}

.free-booking-item .txt {
  padding-top: 10px;
  display: block;
  width: 100%;
  color: #ffebbf;
}
.txt1 {
  width: auto !important;
  padding-bottom: 5px;
}

.free-booking-item-order .txt {
  padding-right: 5px;
  display: block;
  width: 100%;
}
.free-booking .tool-button-primary {
}
.free-booking-item img {
  margin-top: 30px;
  width: 600px;
}
.free-booking .element-row {
  flex-flow: row wrap;
}
.free-booking .tool-button {
  width: 100%;
  position: relative;
  font-weight: 700;
  font-size: 16px;
  /* color: #222; */
  background-color: #ffebbf;
  color: #9f6548;
  font-weight: 700;
  cursor: pointer;
  padding: 0px 70px;
  letter-spacing: 1.6px;
  text-align: center;
  border-radius: 2px;
  height: 44px;
  line-height: 44px;
}
.el-icon-eat {
  /* background: url('~@/assets/image/export.png') center no-repeat; */
  /* background-size: cover;*/
}
.el-icon-eat:before {
  content: "替";
  font-size: 16px;
  visibility: hidden;
}
.el-icon-eat {
  font-size: 16px;
}
.el-icon-eat:before {
  content: "\e611";
}
</style>
// 弹出框
<style scoped>
.tool-booking {
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 2003;
}
.tool-booking-order {
  position: absolute;
  top: 50%;
  left: 50%;
  background: #fff;
  border-radius: 14px;
  width: 616px;
  margin-top: -263px;
  margin-left: -308px;
  padding: 25px 51px;
}

.request::before {
  content: "*";
  color: red;
  position: relative;
}
.tool-booking .element-row,
.tool-booking .element-row:after,
.tool-booking .element-row:before {
  display: flex;
  justify-content: center;
}
.tool-booking .element-row {
  flex-flow: row wrap;
}
.tool-booking .tool-booking-order .tool-booking-order-close {
  display: block;
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  right: 0;
  line-height: 60px;
  text-align: center;
  font-size: 30px;
  cursor: pointer;
  border-radius: 0 14px 0 0;
  transition: all 0.2s ease-in-out;
}
.tool-booking .element-col-span-12 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}
.tool-booking .element-col {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.tool-booking .element-col-simple {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: nowrap;
  justify-items: flex-start;
  align-items: center;
}
.tool-booking .element-col-canwrap {
  position: relative;
  max-width: 100%;
  min-height: 1px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.tool-booking .tool-booking-order .tool-booking-order-submit {
  margin-top: 60px;
}
.tool-button-primary {
  background: #222;
}
.tool-booking .sendCode {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  border: none;
  background: #f8f8f8;
  border-radius: 6px;
}
.tool-booking .sendCode >>> .el-input__inner {
  border: none;
  border-color: transparent;
  background: fixed;
  width: 100px !important;
  margin-top: 0px !important;
}
.tool-booking .sendCode span {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: #f9541c;
  cursor: pointer;
  width: 80px;
  opacity: 0.2;
}
.tool-booking .sendCode .active-txt2 {
  flex-shrink: 0;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  color: #f9541c;
  cursor: pointer;
  width: 80px;
  opacity: 1;
}
.tool-booking .tool-button {
  position: relative;
  font-weight: 700;
  font-size: 16px;
  /* color: #222; */
  background-color: #ffebbf;
  color: #9f6548;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 1.6px;
  text-align: center;
  border-radius: 2px;
  height: 44px;
  line-height: 44px;
  top: 15px;
}

.tool-booking .element-col-push-8 {
  left: 33.33333333%;
}
.tool-booking .element-col-span-8 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
/* el-select 样式 */
.tool-booking >>> .el-input__inner {
  /* border: none; 
    border-color: transparent ;
    
    color:#000;
    font-weight: 700; */
  background: #f8f8f8;
  border: none;
  width: 180px !important;
}
.tool-booking >>> .el-select-dropdown__item {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
}
.tool-booking >>>.el-select-dropdown__list .selected {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  color: #606266 !important;
}
.tool-booking >>> .el-select-dropdown__item:hover {
  /* height: 45px !important;
    font-size: 20px !important;
    line-height: 45px; */
  background: #f8f8f8;
}

.tool-booking >>> .el-input {
  display: inline !important;
}
.tool-booking >>> .el-input input {
  display: block;
}
.tool-booking-order .txt {
  padding-right: 5px;
  display: block;
  width: 100%;
}
.txt1 {
  width: auto !important;
  padding-bottom: 5px;
}
.tool-booking >>> .el-textarea__inner {
  background: #f8f8f8;
  width: 490px;
  border: none;
  min-height: 100px !important;
}

.tool-booking >>> .inner-textarea {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 60px;
}

.tool-button-primary button {
  color: #fff;
  font-weight: 700;
}
.tool-button button {
  outline: none;
  background: none;
  border: none;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.element-col img {
  margin-top: 30px;
  width: 600px;
}
.tool-booking-order .title {
  font-weight: 700;
  font-size: 20px;
  color: #222;
}
.tool-booking-order .subtitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: space-between;
}
.tool-booking-order .subtitle .subtitle-left {
}
.subtitle-left .header-tags {
  margin-top: 10px;
}
.subtitle-left .header-tags span {
  font-weight: 700;
  font-size: 14px;
  color: #222;
  line-height: 33px;
  height: 33px;
}
.tool-booking-order .subtitle .subtitle-right {
}
.tool-booking-order .subtitle .subtitle-right .price {
  font-weight: 700;
  font-size: 20px;
  color: #fa5821;
  text-align: left;
  margin-top: 14px;
  text-align: right;
}
.tool-booking-order .subtitle .subtitle-right .price::after {
  content: "元起/人";
  font-weight: 700;
  font-size: 12px;
  color: #666;
  text-align: left;
  line-height: 28px;
}
.tool-booking-order .subtitle .subtitle-right .avg-pirce {
  text-align: right;
}
.three>>> img ,.four-detail>>> img,.five-detail>>> img{
  width: 100%;
}
.three table tbody td >>>ul,.four-detail>>>ul,.five-detail>>>ul{
  padding-left: 20px;
}
.three table tbody td >>>ul li,.four-detail>>>ul li,.five-detail>>>ul li{
  list-style: initial;
}
.loading-page{
  height: 800px;
  width: 100%;
}


.qrcode-show >>> .el-dialog__title{
  display: inline-block;
  margin-top: 40px;
  /* width: 250px; */
  text-align: center;
}
.qrcode-show >>> .el-dialog__body{
  padding-top:0px;
}
.qrcode-show >>> .el-dialog__body img{
  margin-top:0px;
}
</style>




// WEBPACK FOOTER //
// src/components/annualMeeting/annualMeetingDetail.vue